/* import __COLOCATED_TEMPLATE__ from './office-details.hbs'; */
import { service } from '@ember/service';
import Component from '@ember/component';
import classic from 'ember-classic-decorator';

@classic
export default class RequestLocationOfficeDetails extends Component {
  @service session;
}
